import { render, staticRenderFns } from "./PartnerBilling.vue?vue&type=template&id=4d98faad"
import script from "./PartnerBilling.vue?vue&type=script&lang=ts"
export * from "./PartnerBilling.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports